/**
 * The add-in's microphone owner for the shared panel (outlook-orachat-uplift s9).
 *
 * The panel asks; this maps the Office acquisition onto the host verdict
 * and always uses the relay for dictation. Nothing here branches on the
 * host name.
 */

import type { HostMicVerdict, OraChatVoiceHost } from "@product-app/features/oraChatV2/transport";

import {
  acquireMicrophone,
  type MicAcquisitionResult,
} from "../features/hostCapability/acquireMicrophone";

function toVerdict(result: MicAcquisitionResult): HostMicVerdict {
  const status =
    result.status === "available"
      ? "available"
      : result.status === "granted_pending_reload"
        ? "needs_reload"
        : result.status === "blocked"
          ? "blocked"
          : "unavailable";
  return {
    status,
    reason: result.reason,
    hostDialogPending: result.hostDialogPending,
  };
}

export const addinVoiceHost: OraChatVoiceHost = {
  stt: "relay",
  acquireMicrophone: async () => toVerdict(await acquireMicrophone()),
};
